class CardCarousel extends HTMLElement {
  constructor() {
    super();
    this.carousel = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.carousel = new Splide(this.querySelector('.splide'),
      {
        arrows: false,
        perPage: 4,
        padding: { right: '8%' },
        gap: 'var(--spacing-sm)',
        trimSpace: false,
        breakpoints: {
          768: {
            perPage: 1,
            padding: { right: '30%' },
            gap: 'var(--spacing-xs)',
            focus: 0,
            trimSpace: false,
          }
        },
      },
    );

    this.carousel.mount();
  }
}

customElements.define('card-carousel', CardCarousel);
